define('drops/rectangle/rectangle',[
    'jquery',
    'lq/drop',
    'lq/style',
    'lq/tooltip',
    'lq/onlongpress',
], function ($, Drop, Style, Tooltip, OnLongPress) {
	'use strict';

    var defaults = {
        data: {
            title: {
                option: Tooltip.hardcoded
            },
        }
    }

    function Rectangle(options) {
        Drop.call(this, $('<div/>'), defaults, options);
       
        this.$element.addClass('boxToBorderSize');
        this.tooltip = new Tooltip(this, this.data.title, this.$element);

        Style.renderStyles(this);
    }
    
    Drop.extend(Rectangle, Drop);

    Rectangle.typeName = 'Rectangle';

    Rectangle.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.applyPosition();
        this.tooltip.update();

        if (this.isEventEnabled('clicked')) {
            new OnLongPress().applyLongPressOnElement(this.$element, this);
            this.$element.addClass('clickable');
        }
    };

    Rectangle.prototype.setValue = function (update) {
        this.setBackgroundColor(update.value);
    };
    
    Rectangle.prototype.clearValue = function () {
        this.setBackgroundColor('');
    };

    Rectangle.prototype.setBackgroundColor = function (color) {
        this.$element.css('background-color', color);
    };

	return Rectangle;
});
